import { SITE_NAME } from '@garagegymbros/domain';

/** Names assigned before a member renames their gym. */
const DEFAULT_GYM_NAMES = new Set(['my gym', 'my garage gym']);

/** Leading top-bar place. A renamed gym replaces the site name. */
export function topbarPlaceLabel(gymName: string | null | undefined) {
  const name = gymName?.trim() ?? '';
  if (!name || DEFAULT_GYM_NAMES.has(name.toLowerCase())) return SITE_NAME;
  return name;
}
